import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icp" }
const _hoisted_2 = { href: "https://beian.miit.gov.cn" }

import DisclaimerPopVue from "./DisclaimerPop.vue";

import { ref } from "vue";

const __default__ = {
  name: "Icp"
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const appName = ref<string>(APP_NAME);
const company = ref<string>(APP_CONFIG_COMPANY_NAME);
const icp = ref<string>(APP_CONFIG_BEI_AN_CODE);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _cache[0] || (_cache[0] = _createTextVNode("ICP备案/许可证号：")),
      _createElementVNode("a", _hoisted_2, _toDisplayString(icp.value), 1)
    ]),
    _createElementVNode("p", null, _toDisplayString(appName.value) + " - " + _toDisplayString(company.value), 1),
    _createVNode(DisclaimerPopVue)
  ]))
}
}

})